'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

function useOpenable() {
  var defaultState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var [isOpen, setIsOpen] = React__namespace.useState(defaultState);
  var handlers = {
    open: () => setIsOpen(true),
    close: () => setIsOpen(false),
    toggle: () => setIsOpen(s => !s)
  };
  return [isOpen, handlers];
}

exports.default = useOpenable;
exports.useOpenable = useOpenable;
